import $ from 'jquery'
import gsap from 'gsap'

/**
 * Faderクラス
 */
class Fader {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //シングルトンインスタンス
  private static _instance: Fader

  //DOM
  private _fader: JQuery

  // ---------------------------------------------------------------------------------------------------------
  // --	Fader
  // ---------------------------------------------------------------------------------------------------------
  /**
   * コンストラクタ
   */
  private constructor() {
    this._fader = $('.c-fader')
  }

  /** インスタンスの取得 */
  public static get instance(): Fader {
    if (!this._instance) {
      this._instance = new Fader()
    }

    // 生成済みのインスタンスを返す
    return this._instance
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	ACTION
  // ----------------------------------------------------------------------------------------------------------------

  fadeIn(duration: number = 0.5, delay: number = 0) {
    return new Promise<void>((resolve, reject) => {
      gsap.killTweensOf(this._fader)
      gsap.to(this._fader, {
        duration,
        delay,
        alpha: 0,
        ease: 'none',
        onComplete: () => {
          this._fader.hide()
          resolve()
        },
      })
    })
  }

  fadeOut(duration: number = 0.5, delay: number = 0) {
    return new Promise<void>((resolve, reject) => {
      gsap.killTweensOf(this._fader)
      gsap.set(this._fader, { alpha: 0 })
      this._fader.show()
      gsap.to(this._fader, {
        duration,
        delay,
        alpha: 1,
        ease: 'none',
        onComplete: () => {
          resolve()
        },
      })
    })
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Fader
